module.exports = __webpack_public_path__ + "static/media/oxxoLogo.477eccb0.png";